export default __webpack_public_path__ + "images/0x9fb9a33956351cf4fa040f65a13b835a3c8764e3.png";